import { render, staticRenderFns } from "./LottoButton.vue?vue&type=template&id=36723e8f&scoped=true&"
import script from "./LottoButton.vue?vue&type=script&lang=js&"
export * from "./LottoButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36723e8f",
  null
  
)

export default component.exports